// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"94f83b45","453":"c2efd3c2","732":"e38a5981"}[chunkId] + ".chunk.js";
};